import { BasicTable } from "@/view/components/BasicTable";
import { Spinner } from "@/view/components/ui/spinner";

import { JourneyFilters } from "./components/JourneyFilters";
import { JourneyFunnel } from "./components/JourneyFunnel";
import { JourneyTimelineModal } from "./components/JourneyTimelineModal";
import { useReportJourneysController } from "./useReportJourneysController";

export const ReportJourneys = () => {
  const {
    table,
    funnel,
    isFetching,
    isLoading,
    isFetchingFunnel,
    filters,
    products,
    getProductLabel,
    selectedJourneyId,
    setSelectedJourneyId,
    handleApplyFilters,
    getPageCount,
    getPageIndex,
    handleNextPage,
    handlePreviousPage,
  } = useReportJourneysController();

  return (
    <div className="w-full">
      <JourneyFilters
        products={products}
        getProductLabel={getProductLabel}
        value={filters}
        onApply={handleApplyFilters}
      />

      <section className="mt-6">
        {isFetchingFunnel && !funnel ? (
          <div className="flex justify-center py-10">
            <Spinner />
          </div>
        ) : (
          <JourneyFunnel funnel={funnel} />
        )}
      </section>

      <section className="mt-8">
        <p className="mb-3 text-sm text-black04">
          Clique numa linha para ver a jornada etapa a etapa.
        </p>

        {isFetching || isLoading ? (
          <div className="flex justify-center py-10">
            <Spinner />
          </div>
        ) : (
          <BasicTable
            type="table with lines"
            table={table}
            getPageCount={getPageCount}
            getPageIndex={getPageIndex}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowClick={(journey) =>
              setSelectedJourneyId(journey.journeyId)
            }
          />
        )}
      </section>

      <JourneyTimelineModal
        journeyId={selectedJourneyId}
        onClose={() => setSelectedJourneyId(undefined)}
      />
    </div>
  );
};
